import React, { useEffect, useState } from 'react';
import { Modal, Form, Select, message, Table, Button, Space } from 'antd';
import { DeleteOutlined, PlusOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import axios from 'axios';
import { Popconfirm } from 'antd';

const { Option } = Select;

const UserClientsModal = ({ visible, onCancel, userId, onSave }) => {
  const [form] = Form.useForm();
  const [clients, setClients] = useState([]);
  const [userClients, setUserClients] = useState([]);
  const [selectedClientId, setSelectedClientId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();

  const fetchClients = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/customers`);
      setClients(res.data);
    } catch {
      messageApi.error('Erro ao buscar clientes');
    }
  };

  const fetchUserClients = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/user_clients/user/${userId}`);
      setUserClients(res.data);
    } catch {
      messageApi.error('Erro ao buscar clientes do usuário');
    }
  };

  useEffect(() => {
    if (visible) {
      fetchClients();
      fetchUserClients();
    }
  }, [visible, userId]);

  const handleAddClient = async () => {
    if (!selectedClientId) {
      return messageApi.warning('Selecione um cliente');
    }

    const alreadyLinked = userClients.some(c => c.idclient === selectedClientId);
    if (alreadyLinked) {
      return messageApi.info('Cliente já vinculado');
    }

    try {
      setLoading(true);
      await axios.post(`${process.env.REACT_APP_API_URL}/user_clients`, {
        iduser: userId,
        idclient: selectedClientId,
        nrisactive: true
      });
      messageApi.success('Cliente vinculado com sucesso');
      setSelectedClientId(null);
      fetchUserClients();
    } catch (error) {
      var apiMsg = 'Erro ao vincular cliente';
      if (error.response?.status != 500) {
        apiMsg +=  ': ' + error.response?.data?.error || '!';
      }
      messageApi.error(apiMsg);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    try {
      await axios.delete(`${process.env.REACT_APP_API_URL}/user_clients/${id}`);
      messageApi.success('Cliente desvinculado com sucesso');
      fetchUserClients();
    } catch (error) {
      var apiMsg = 'Erro ao desvincular cliente';
      if (error.response?.status != 500) {
        apiMsg +=  ': ' + error.response?.data?.error || '!';
      }
      messageApi.error(apiMsg);
    }
  };

  const columns = [
    {
      title: 'Cliente',
      dataIndex: 'client',
      key: 'client',
      render: (client) => client?.dsname || '-'
    },
    {
      title: 'Status',
      dataIndex: 'nrisactive',
      key: 'nrisactive',
      render: (isActive) => isActive ? 'Ativo' : 'Inativo'
    },
    {
      title: 'Ações',
      key: 'actions',
      render: (_, record) => (
        <Popconfirm
          title="Deseja desvincular este cliente?"
          icon={<ExclamationCircleOutlined style={{ color: 'red' }} />}
          onConfirm={() => handleDelete(record.id)}
          okText="Sim"
          cancelText="Cancelar"
        >
          <Button danger icon={<DeleteOutlined />} />
        </Popconfirm>
      )
    }
  ];

  const availableClients = clients.filter(
    (client) => !userClients.some(uc => uc.idclient === client.id)
  );

  return (
    <Modal
      open={visible}
      title="Vincular Clientes ao Usuário"
      onCancel={onCancel}
      onOk={onSave}
      footer={null}
      width={800}
    >
      {contextHolder}

      <Space style={{ marginBottom: 16 }}>
        <Select
          style={{ width: '13em' }}
          placeholder="Selecione um cliente"
          value={selectedClientId}
          onChange={setSelectedClientId}
          allowClear
          showSearch
          optionFilterProp="children"
          filterOption={(input, option) =>
            option.children.toLowerCase().includes(input.toLowerCase())
          }
        >
          {availableClients.map(client => (
            <Option key={client.id} value={client.id}>
              {client.dsname}
            </Option>
          ))}
        </Select>
        <Button
          type="primary"
          icon={<PlusOutlined />}
          onClick={handleAddClient}
          loading={loading}
        >
          Adicionar
        </Button>
      </Space>

      
      <Table
        dataSource={userClients}
        columns={columns}
        rowKey="id"
        pagination={false}
      />
    </Modal>
  );
};

export default UserClientsModal;
